module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Book-b91dd7ed3a48a27a98c6c78b4407b225.otf";